import { render, staticRenderFns } from "./ProgrammDescription.vue?vue&type=template&id=26c07ef5&scoped=true&"
import script from "./ProgrammDescription.vue?vue&type=script&lang=js&"
export * from "./ProgrammDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c07ef5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/ProgrammDescription.vue
// module id = null
// module chunks = 